export default __webpack_public_path__ + "static/bw-walch-logo-4156440a10cbb564aa63cc438b1d6038.png";